import React, { useState, useEffect } from 'react';
import { useNavigate ,useLocation} from 'react-router-dom';
import { signInWithPopup, OAuthProvider } from 'firebase/auth';
import { auth } from '../../firebaseConfig';
import { jwtDecode } from 'jwt-decode';
import ContentImage from '../../assets/authContentImage.png';
import MicrosoftIcon from '../../assets/ms-login.svg';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { IpInfoResponse } from '../../types/authTypes';
import { useDispatch } from 'react-redux';
import { setUserPlan } from '../../redux/slices/userSlice';
export interface DecodedToken {
  email: string;
  name: string;
  picture?: string;
  exp?: number; // Add this line to include expiration time
}


function Login() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const defaultAvatarUrl =
    'https://github.com/parati-eos/EOS_DEPLOYMENT/blob/main/download__11_-removebg-preview%20(1).png?raw=true';
  const location = useLocation();

  useEffect(() => {
    const checkTokenExpiry = (token: string | null) => {
      if (!token) return;

      try {
        const decoded: DecodedToken = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);

        if (decoded.exp && decoded.exp > currentTime) {
          const timeoutDuration = (decoded.exp - currentTime) * 1000;
          setTimeout(() => {
            handleLogout();
          }, timeoutDuration);
        } else {
          handleLogout();
        }
      } catch (error) {
        console.error('Invalid token:', error);
        handleLogout();
      }
    };

    const handleLogout = () => {
      localStorage.removeItem('token');
      window.location.reload();
    };

    const token = localStorage.getItem('token');
    checkTokenExpiry(token);
  }, []);

  const generateOrgId = () => 'Parati-' + Date.now();
  const generatedOrgId = generateOrgId();

  const handleGoogleSuccess = (credentialResponse: any) => {
    const decoded: DecodedToken = jwtDecode(credentialResponse.credential);
    sessionStorage.setItem('userEmail', decoded.email);
    sessionStorage.setItem('userDP', decoded.picture || defaultAvatarUrl);
    sessionStorage.setItem('referrerName', decoded.name);

    const userData = {
      name: decoded.name,
      email: decoded.email,
    }

    // Send user data to MongoDB via API
    saveUserData(userData)
  }

  const handleMicrosoftLogin = async () => {
    const provider = new OAuthProvider('microsoft.com')
    try {
      const result = await signInWithPopup(auth, provider)
      if (result && result.user) {
        const userData = {
          name: result.user.displayName || '',
          email: result.user.email || '',
          picture: result.user.photoURL || defaultAvatarUrl,
        }

        saveUserData(userData)
        sessionStorage.setItem('userEmail', userData.email)
        sessionStorage.setItem('userDP', userData.picture)
        

      } else {
        throw new Error('Microsoft Login Failed: No access token found')
      }
    } catch (error) {
      console.error('Microsoft Login Failed:', error)
    }
  }

  const saveUserData = async (userData: Record<string, any>) => {
    setIsLoading(true)
    const signupLink = localStorage.getItem('sign_up_link') || ''
    try {
      const ipInfoResponse = await fetch(
        'https://api.zynth.ai/api/v1/data/userprofile/ip-info'
      )
      const ipInfoData: IpInfoResponse = await ipInfoResponse.json()

      const userPayload = {
        userId: userData.email,
        name: userData.name,
        orgId: generatedOrgId,
        pptCount: 0,
        userIPCountry: ipInfoData.country!,
        signupLink: signupLink,
        source:"Platform",
        currentSource:"Platform"
      
      }

      sessionStorage.setItem('country',userPayload.userIPCountry)
      sessionStorage.setItem('address',ipInfoData.city!+","+ipInfoData.region!+","+ipInfoData.country!)
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/userprofile/user`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(userPayload),
        }
      );

      const responseData = await res.json();
      const name = responseData.userProfile.name || userData.name;
      sessionStorage.setItem('userName', name);
      // Check if user came from new-presentation page
      // const autoSubmitAfterAuth = sessionStorage.getItem('autoSubmitAfterAuth');
      
      // if (responseData.orgid 
      //   && responseData.plan?.plan_name) {
      //   dispatch(setUserPlan(responseData.plan.plan_name));
      //   sessionStorage.setItem('orgId', responseData.orgid);
      //   // Redirect back to new-presentation if they were filling the form
      //   navigate(autoSubmitAfterAuth ? '/new-presentation' : '/new-presentation');
      // } 
      // else if(
      //   responseData.orgid 
      //   && !responseData.plan?.plan_name
      //  ) {
      //   sessionStorage.setItem('orgId', responseData.orgid);
      //   // Redirect back to new-presentation if they were filling the form
      //   navigate(autoSubmitAfterAuth ? '/new-presentation' : '/new-presentation');
      // }
      // else {
      //   sessionStorage.setItem('orgId', generatedOrgId);
      //   // If they were filling form, go to new-presentation after onboarding
      //   navigate(autoSubmitAfterAuth ? '/new-presentation' : '/onboarding');
      // }
    
    // const params = new URLSearchParams(location.search);
    // const redirectUrl = params.get("redirect");
   const redirect = sessionStorage.getItem("redirectAfterAuth");
    // if (redirectUrl) {
    //   sessionStorage.setItem("redirectAfterAuth", redirectUrl);
    // }

    if (!responseData.orgid) {
      // New user → force onboarding
      sessionStorage.setItem('orgId', generatedOrgId);
      navigate('/onboarding');
    } else {
      sessionStorage.setItem('orgId', responseData.orgid);
      if (responseData.plan?.plan_name) {
        dispatch(setUserPlan(responseData.plan.plan_name));
      }

      // If user finished onboarding, check for redirect
      
      if (redirect) {
        navigate(redirect);
        sessionStorage.removeItem("redirectAfterAuth"); // cleanup
      } else {
        navigate('/new-presentation'); // default
      }
    }
      sessionStorage.setItem('authToken', responseData.token);
      sessionStorage.setItem('role', responseData.role || 'admin');
    } catch (error) {
      console.error('Error storing user data:', error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="relative flex flex-col shadow-lg h-screen">
      {isLoading ? (
        <div className="w-full min-h-screen flex items-center justify-center">
          <div className="w-10 h-10 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
        </div>
      ) : (
        <>
          {/* Background Split */}
          <div className="absolute top-0 left-0 w-full h-3/4 md:h-1/2 bg-[#3667B2]"></div>
          <div className="absolute bottom-0 left-0 w-full h-1/4 md:h-1/2 bg-white"></div>

          <div className="relative flex flex-col md:flex-row justify-center items-center h-full w-full">
            {/* Image Section */}
            <div className="flex justify-center items-center h-[50vh]  md:h-full w-full md:w-1/2 md:px-0">
              <img
                src={ContentImage}
                alt="Auth"
                className="h-full w-full  md:max-h-none object-cover "
                loading="lazy"
              />
            </div>
            {/* Buttons Section */}
            <div className="flex justify-center items-center h-[60vh] md:h-full w-full md:w-1/2 px-6 md:px-12">
              <div className="p-6 bg-transparent border-2 border-[#004264] shadow-lg text-white rounded-lg flex flex-col items-center w-full max-w-md">
                <h1 className="text-2xl md:text-3xl font-bold lg:mb-2 md:mb-4">
                  Login
                </h1>
                <div className="flex flex-col justify-center items-center">
                  <span className="hover:scale-105">
                    <GoogleOAuthProvider clientId="1053104378274-jchabnb9vv91n94l76g97aeuuqmrokt9.apps.googleusercontent.com">
                      <GoogleLogin onSuccess={handleGoogleSuccess} />
                    </GoogleOAuthProvider>
                  </span>
                  <img
                    onClick={handleMicrosoftLogin}
                    src={MicrosoftIcon}
                    alt="Microsoft Login"
                    className="w-full h-full mt-4 hover:cursor-pointer hover:scale-105"
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Login
